.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--nexus-space-md);
  min-height: 48px;
}

.loading {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-sm);
}

.loadingText {
  font-size: var(--nexus-text-xs);
  color: var(--nexus-text-muted);
  font-weight: var(--nexus-weight-medium);
}

.endText {
  font-size: var(--nexus-text-xs);
  color: var(--nexus-text-muted);
}

.pullHint {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-xs);
  opacity: 0.7;
}

.pullText {
  font-size: var(--nexus-text-xs);
  color: var(--nexus-text-muted);
}
